import { LinkButton } from '@cian/ui-kit/button';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getModerateUrl } from './getModerateUrl';
import * as styles from './styles.css';
import { selectQueryString } from '../../../common/selectors/queryString';
import { selectCanModerateAnnouncements } from '../../../common/selectors/user';

export const ModerateButtonContainer: React.FC = () => {
  const canModerateAnnouncements = useSelector(selectCanModerateAnnouncements);
  const queryString = useSelector(selectQueryString);

  if (!canModerateAnnouncements) {
    return null;
  }

  return (
    <div className={styles['root']}>
      <LinkButton
        data-testid="moderate-button"
        href={getModerateUrl(queryString)}
        size="XS"
        target="_blank"
        theme="fill_error_secondary"
      >
        Проверять
      </LinkButton>
    </div>
  );
};

ModerateButtonContainer.displayName = 'ModerateButtonContainer';
